/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import reactUpdate from 'immutability-helper';
import React from 'react';

import * as RegistryConstants from 'constants/RegistryConstants';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {TextFieldType} from 'ui-library/inputs/EditableTextField';
import * as LoadingScreen from 'ui-library/LoadingScreen';
import SettingsField from 'ui-library/SettingsField';

const {SAVING_STATES} = RegistryConstants;

export interface PrinterSettingsProps {
  isBeingCreated: boolean;
  isWritable: boolean;
  onCreate: (...args: Array<any>) => any;
  onUpdate: (...args: Array<any>) => any;
  printer?: any; // TODO: SampleConstants.PRINTER_SHAPE
  savingState: any; // TODO: PropTypes.oneOf(Object.keys(SAVING_STATES))
}

type State = any;

class PrinterSettings extends React.Component<PrinterSettingsProps, State> {
  constructor(props: PrinterSettingsProps) {
    super(props);
    let printer;
    if (props.printer) {
      printer = props.printer;
    } else {
      printer = {
        name: '',
        address: '',
        port: '',
        description: '',
      };
    }
    this.state = {printer};
  }

  UNSAFE_componentWillReceiveProps(nextProps: PrinterSettingsProps): void {
    if (nextProps.printer) {
      this.setState({printer: nextProps.printer});
    }
  }

  componentDidUpdate(prevProps: PrinterSettingsProps, prevState: State): void {
    const wasSaving = prevProps.savingState === SAVING_STATES.PENDING;
    const isSaving = this.props.savingState === SAVING_STATES.PENDING;
    if (!wasSaving && isSaving) {
      // Saving started
      LoadingScreen.show('Saving...');
    } else if (wasSaving && !isSaving) {
      // Saving finished
      LoadingScreen.hide();
    }
  }

  _handleChangePrinter = (update: any): void => {
    const printer = reactUpdate(this.state.printer, {$merge: update});
    this.setState({printer});
    if (!this.props.isBeingCreated) {
      this._handleSubmit(null, printer);
    }
  };

  _handleSubmit = (e: any, printer = this.state.printer): void => {
    if (this.props.isBeingCreated) {
      this.props.onCreate(printer);
      return;
    }
    this.props.onUpdate(printer);
  };

  _handleChangeName = (name: any): void => {
    this._handleChangePrinter({name});
  };

  _handleChangeAddress = (address: any): void => {
    this._handleChangePrinter({address});
  };

  _handleChangePort = (port: any): void => {
    this._handleChangePrinter({port});
  };

  _handleChangeDescription = (description: any): void => {
    this._handleChangePrinter({description});
  };

  render(): JSX.Element {
    return (
      <div className="u-flex-grow">
        <div className="settingsPageContainer-section">
          <Row>
            <Col sm={5}>
              <SettingsField
                isBeingCreated={this.props.isBeingCreated}
                isRequired={true}
                isWritable={this.props.isWritable}
                label="Name"
                name="name"
                onChange={this._handleChangeName}
                value={this.state.printer.name}
              />
            </Col>
            <Col sm={5}>
              <SettingsField
                isBeingCreated={this.props.isBeingCreated}
                isRequired={true}
                isWritable={this.props.isWritable}
                label="Address"
                name="address"
                onChange={this._handleChangeAddress}
                value={this.state.printer.address}
              />
            </Col>
            <Col sm={2}>
              <SettingsField
                isBeingCreated={this.props.isBeingCreated}
                isWritable={this.props.isWritable}
                label="Port"
                name="port"
                onChange={this._handleChangePort}
                type={TextFieldType.NUMBER}
                value={this.state.printer.port}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <SettingsField
                isBeingCreated={this.props.isBeingCreated}
                isWritable={this.props.isWritable}
                label="Description"
                name="description"
                onChange={this._handleChangeDescription}
                value={this.state.printer.description}
              />
            </Col>
          </Row>
        </div>
        {this.props.isBeingCreated && (
          <Button
            buttonStyle={ButtonStyle.PRIMARY}
            disabled={!this.props.isWritable}
            onClick={this._handleSubmit}
            size={ButtonSize.MEDIUM}
            text="Create"
          />
        )}
      </div>
    );
  }
}

export default PrinterSettings;
